import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";

import App from "./App.tsx";
import "./index.css";

// Detect Capacitor native context
const isCapacitor = !!(window as any).Capacitor?.isNativePlatform?.();

// Register the service worker (offline cache + web push) on published domains only.
// Never in Capacitor, Lovable preview/dev sandboxes or inside an iframe.
const host = window.location.hostname;
const isPreviewHost =
  host.startsWith("id-preview--") ||
  host.startsWith("preview--") ||
  host.includes("-preview--") ||
  host === "localhost" ||
  host === "127.0.0.1" ||
  host.endsWith(".lovableproject.com") ||
  host.endsWith(".lovableproject-dev.com") ||
  host.endsWith(".beta.lovable.dev");
const isInIframe = window.self !== window.top;
const swDisabled = new URLSearchParams(window.location.search).get("sw") === "off";

const isProduction = !isCapacitor && !isPreviewHost && !isInIframe && !swDisabled && import.meta.env.PROD;

if ("serviceWorker" in navigator) {
  if (isProduction) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    // In preview/dev: unregister old workers and clear caches
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister())
    );
    if ("caches" in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <App />
    </ThemeProvider>
  </HelmetProvider>
);

